import { ArrowUpRight, Clock, MapPin, Phone } from "lucide-react";
import { MAPS_DIRECTIONS, MAPS_EMBED, OFFICE_HOURS, PHONE_DISPLAY, TEL_LINK, WA_LINK } from "@/lib/site";
import { Reveal } from "./Reveal";
import { WhatsAppIcon } from "./icons";

export const Contact = () => (
  <section id="contact" className="pb-20 sm:pb-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <div
          data-testid="contact-section"
          className="relative bg-ink text-paper rounded-[2.5rem] px-6 py-16 sm:px-12 sm:py-20 lg:py-24 text-center overflow-hidden"
        >
          <div
            aria-hidden="true"
            className="absolute -top-32 left-1/2 -translate-x-1/2 w-[560px] h-[360px] rounded-full bg-brand/25 blur-3xl"
          />
          <div
            aria-hidden="true"
            className="absolute -bottom-40 -right-24 w-[420px] h-[320px] rounded-full bg-gold/20 blur-3xl"
          />

          <div className="relative">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">
              06 — Contact
            </p>
            <h2 className="mt-5 font-display font-medium text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl mx-auto">
              Ek call mein loan
              <br />
              <em className="italic text-gold">shuru</em> kijiye.
            </h2>

            <a
              data-testid="contact-phone-link"
              href={TEL_LINK}
              className="mt-10 inline-block font-display text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tight underline decoration-gold/60 decoration-[3px] underline-offset-8 hover:text-gold hover:decoration-gold transition-colors"
            >
              {PHONE_DISPLAY}
            </a>

            <p className="mt-6 text-paper/60">
              Tap kijiye aur turant call lag jayegi — koi form nahi, koi wait nahi.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3 sm:gap-4">
              <a
                data-testid="contact-call-cta"
                href={TEL_LINK}
                className="inline-flex items-center justify-center gap-2.5 rounded-full bg-gold text-ink px-8 py-4 text-base font-semibold hover:bg-paper transition-colors"
              >
                <Phone className="w-4 h-4" /> Abhi Call Karein
              </a>
              <a
                data-testid="contact-whatsapp-cta"
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2.5 rounded-full bg-wa text-white px-8 py-4 text-base font-semibold hover:bg-brand transition-colors"
              >
                <WhatsAppIcon className="w-5 h-5" /> WhatsApp Kijiye
              </a>
            </div>

            <div className="mt-12 grid lg:grid-cols-5 gap-5 sm:gap-6 text-left">
              <div
                data-testid="contact-address-card"
                className="lg:col-span-2 bg-white/5 border border-white/10 rounded-3xl p-7 sm:p-8 flex flex-col"
              >
                <span className="grid place-items-center w-12 h-12 rounded-2xl bg-gold/15 text-gold">
                  <MapPin className="w-5 h-5" />
                </span>
                <p className="mt-6 font-display text-2xl font-medium text-paper">
                  Hamara Office
                </p>
                <p data-testid="contact-address" className="mt-3 text-paper/70 leading-relaxed">
                  3, Peelwa Garden, Moti Dongri Road,
                  <br />
                  Adarsh Nagar, Jaipur, Rajasthan 302004, India
                </p>
                <p
                  data-testid="contact-timing"
                  className="mt-4 inline-flex items-center gap-2 rounded-full bg-white/5 border border-white/10 px-4 py-2 text-sm text-paper/80"
                >
                  <Clock className="w-4 h-4 text-gold" />
                  {OFFICE_HOURS}
                </p>
                <a
                  data-testid="contact-directions-link"
                  href={MAPS_DIRECTIONS}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto pt-6 inline-flex items-center gap-2 text-sm font-semibold text-gold hover:text-paper transition-colors"
                >
                  Google Maps par Directions lein <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>
              <div
                data-testid="contact-map-embed"
                className="lg:col-span-3 rounded-3xl overflow-hidden border border-white/10 min-h-[280px]"
              >
                <iframe
                  title="Satyam Financial office location — Jaipur"
                  src={MAPS_EMBED}
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                  className="w-full h-full min-h-[280px]"
                  style={{ border: 0, filter: "grayscale(30%) contrast(1.05)" }}
                />
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
